export enum SimulationAdditionalQuestionAnswerType {
  default = 'default',
  custom = 'custom',
}
